const items = [
  "Peinture intérieure minérale",
  "Ravalement de façade & enduits à la chaux",
  "Rénovation complète du bâtiment",
  "Revêtements de sols & boiseries",
  "Isolation & traitement des supports",
  "Garantie décennale française",
  "Chantiers nettoyés au quotidien",
  "Devis détaillé sous huitaine après rendez-vous",
];

export const EditorialMarquee = () => {
  const row = [...items, ...items];
  return (
    <div
      className="relative overflow-hidden bg-[#F3EFE8] border-y border-[#1A1714]/10 py-5"
      data-testid="editorial-marquee-container"
    >
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-serif-display italic text-xl text-[#574E45]">{item}</span>
            <span className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-[#9E5A38]">· LL ·</span>
          </span>
        ))}
      </div>
    </div>
  );
};
